import MarketingPage from "../components/MarketingPage";
import { APP_STORE_URL, ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema } from "../lib/seo";

export default function ShopAndTry() {
  return (
    <MarketingPage
      seo={{
        title: "Shop & Try Clothes Virtually | C-STYL",
        description: "Found something you love online? Bring it into C-STYL and see how it could look on you before adding it to your wardrobe or buying it.",
        path: "/shop-and-try",
        testid: "shop-and-try-page",
        jsonLd: [ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Shop & Try", path: "/shop-and-try" }])],
      }}
      crumb="Shop & Try"
      eyebrow="Try before you buy"
      h1="Try Clothes Before You Buy"
      lead="Found something you love online? Bring it into C-STYL and see how it could look on you before adding it to your wardrobe."
      sections={[
        { h2: "How Shop & Try works", bullets: ["Import a product by pasting its link", "Use saved store shortcuts for quick access", "Browse editor's picks", "Preview the item on your body with virtual try-on", "Add the piece to your digital closet if you love it"] },
        { h2: "Store shortcuts", p: ["You can save your favourite stores for quick access — for example Zara, H&M, ASOS, Nordstrom, Uniqlo or Mango — or add your own. These are shortcuts to shop; they are not partnered with or endorsed by C-STYL."] },
        { h2: "See it before you commit", p: ["Shop & Try pairs with AI virtual try-on so you can visualize a prospective purchase on yourself first, helping you buy with more confidence."] },
      ]}
      cta={{ label: "Download C-STYL", href: APP_STORE_URL, external: true }}
    />
  );
}
